import React, {ForwardedRef, forwardRef} from 'react';
import classnames from 'classnames/bind';
import {useSelector} from 'react-redux';

import OilBaseInfomation from '../../OilBaseInfomation';
import OilVolumesService from '../../OilVolumesService';
import OilThumb from '../../OilThumb';

import logo from '../../../images/castrol-logo.svg';

import {
  IComponentVolumes,
  Replacement,
  IProd,
  IVehicle,
  IState,
} from '../../../interface';
import localesReplacement from '../../../utils/localesReplacement';

import style from './index.module.scss';

const cx = classnames.bind(style);

interface IProps {
  data: IProd;
  vehicle: IVehicle | undefined;
  componentName: string;
  volumes: IComponentVolumes[];
  notes?: string[];
  title?: string;
}

/* eslint-disable react/display-name */
const RecommendedProductPrintable = forwardRef(
  (props: IProps, ref: ForwardedRef<HTMLDivElement>) => {
    const replacements: Replacement = useSelector(
      (state: IState) => state.replacements as Replacement,
    );
    const {data, vehicle, notes, componentName, title, volumes} = props;
    return (
      <div ref={ref} className={cx('printable')}>
        <header>
          <img src={logo} />
        </header>
        <div className={cx('wrapper')}>
          <h1>
            {vehicle?.make} - {vehicle?.model} - {vehicle?.type}
          </h1>
          <u>{componentName}</u>
          <h3>
            {localesReplacement(
              replacements,
              title || 'Castrol Recommendation',
            )}
          </h3>
          <div className={cx('container')}>
            <div>
              <OilThumb withoutMoreLink={true} dataList={data} />
            </div>
            <div>
              <OilBaseInfomation
                withoutMoreLink={true}
                dataList={data}
                productCategories={[]}
                withTitle={false}
              />
            </div>
            <div className={cx('volumes')}>
              <OilVolumesService
                withoutMoreLink={true}
                dataList={data}
                componentVolumes={volumes}
                notes={notes}
              />
            </div>
          </div>
        </div>
        <footer>
          <small>
            {localesReplacement(
              replacements,
              `Please note: All rights reserved: No part of this information may be reproduced, stored in retrieval system or transmitted in any form or by any means
            without the prior permission in writing from the publisher. Third party data is used to determine the recommended product for your vehicle. Castrol accepts
            no liability (to the extent permitted by law) for the accuracy or suitability of any recommendation made. Any decisions you make based on the information
            on this site and any recommendation made on this site are your sole responsibility. Before adding any products to your vehicle, please always check the
            relevant technical specifications in your vehicle user guide for compatibility.`,
            )}
          </small>
        </footer>
      </div>
    );
  },
);

export default RecommendedProductPrintable;
